/* ============================================================
   Royal Perfumerie — Dark Premium Layout behaviors
   Search overlay + injected header search trigger.
   ============================================================ */
(function () {
  "use strict";
  if (!document.body.classList.contains("rp-light")) return;

  function searchUrl() {
    return (window.theme && window.theme.routes && window.theme.routes.cart)
      ? "/search" : "/search";
  }

  /* Build the full-screen search overlay */
  function buildSearchOverlay() {
    var ov = document.createElement("div");
    ov.className = "rp-search-overlay";
    ov.innerHTML =
      '<form action="/search" method="get" role="search">' +
        '<button type="button" class="rp-search-overlay__close" aria-label="Close">&times;</button>' +
        '<input type="search" name="q" placeholder="Search fragrances, brands, notes..." autocomplete="off" aria-label="Search">' +
        '<p class="rp-search-overlay__hint">Press Enter to search &nbsp;·&nbsp; Esc to close</p>' +
      '</form>';
    document.body.appendChild(ov);

    var input = ov.querySelector("input");
    var closeBtn = ov.querySelector(".rp-search-overlay__close");

    function open() {
      ov.classList.add("is-open");
      setTimeout(function () { input.focus(); }, 120);
    }
    function close() { ov.classList.remove("is-open"); }

    closeBtn.addEventListener("click", close);
    ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });

    return { open: open, close: close };
  }

  /* Inject a search trigger icon into the header actions */
  function injectTrigger(overlay) {
    var actions = document.querySelector(".ge-header__actions");
    if (!actions) return;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "rp-search-trigger";
    btn.setAttribute("aria-label", "Search");
    btn.innerHTML =
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
      '<circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    btn.addEventListener("click", overlay.open);
    actions.insertBefore(btn, actions.firstChild);
  }

  function init() {
    var overlay = buildSearchOverlay();
    injectTrigger(overlay);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
